import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KycService } from '@app/core/kyc.service';
import { Injectable } from '@angular/core';

@Injectable()
export class MyFinancialRouteGuard implements CanActivate {

    constructor(private kycService: KycService, private router: Router) {
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const isMyFinancialCompleted = this.kycService.kyc.financial.completed;
      if (!isMyFinancialCompleted) {
            let tenant = this.kycService.getTenant();
            this.router.navigate([tenant, 'journey', 'profile']);
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/route-guard/my-financial-route-guard.ts